export const Logo = ({ size = 44 }) => (
  <img
    src="/images/wordmark.png"
    alt="Disco Dogs"
    data-testid="disco-dogs-logo"
    style={{ height: size, width: "auto" }}
    className="object-contain select-none"
    draggable={false}
  />
);

export default Logo;
